module.exports = __webpack_public_path__ + "img/w3_pdf_grey.3e6d4de4.png";